/* =========================================================================
   Workshop — animations.js
   Scroll reveals via IntersectionObserver. Adds .is-visible to [data-animate].
   Respects prefers-reduced-motion and the theme animations toggle.
   ========================================================================= */
(function () {
  'use strict';

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || (window.theme && window.theme.animations === false)) {
    document.querySelectorAll('[data-animate]').forEach((el) => el.classList.add('is-visible'));
    document.body.classList.remove('animate-media');
    return;
  }

  document.body.classList.add('animate-media');

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const delay = el.getAttribute('data-animate-delay');
      if (delay) el.style.transitionDelay = delay + 'ms';
      el.classList.add('is-visible');
      obs.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  function observeAll(scope) {
    (scope || document).querySelectorAll('[data-animate]:not(.is-visible)').forEach((el) => observer.observe(el));
  }
  observeAll();

  // Auto-stagger children of [data-animate-group]
  document.querySelectorAll('[data-animate-group]').forEach((group) => {
    const step = parseInt(group.getAttribute('data-animate-group') || '80', 10);
    group.querySelectorAll('[data-animate]').forEach((child, i) => {
      if (!child.getAttribute('data-animate-delay')) child.setAttribute('data-animate-delay', i * step);
    });
  });

  /* ---------- Lightweight parallax ---------- */
  const parallaxEls = document.querySelectorAll('[data-parallax]');
  if (parallaxEls.length) {
    let ticking = false;
    const update = () => {
      parallaxEls.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const speed = parseFloat(el.getAttribute('data-parallax')) || 0.15;
        const offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  // Re-run in the theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => observeAll(e.target));
  }
  window.WorkshopObserveAnimations = observeAll;
})();
